export const META_TYPE = 'workspaceCtrl';
export const META_VER = 'v1';
export const WSC_TARGET = 'all';

export const CMD_WORKSPACE_CTRL_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
